export const SYSTEM_ACCOUNT_TYPE = "מערכת" as const;
export const SYSTEM_PATH = "/system";
export const SYSTEMS_BREADCRUMB = { ledger: "כרטסות", list: "מערכת" } as const;
export const SYSTEMS_STRUCTURE_CRUMBS = {
  browse: "הגדרת מבנה דפדוף",
} as const;